module.exports = __webpack_public_path__ + "img/toplogo.a26fdb53.png";